/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const powerElectricalSystemsEnumsAffectedRedundancyLevelOptionEnum = {
    NPlus1: 'NPlus1',
    V2N: 'V2N',
    SinglePointOfFailure: 'SinglePointOfFailure',
    Other: 'Other',
} as const;

export type PowerElectricalSystemsEnumsAffectedRedundancyLevelOptionEnumKey =
    (typeof powerElectricalSystemsEnumsAffectedRedundancyLevelOptionEnum)[keyof typeof powerElectricalSystemsEnumsAffectedRedundancyLevelOptionEnum];

export type PowerElectricalSystemsEnumsAffectedRedundancyLevelOption =
    PowerElectricalSystemsEnumsAffectedRedundancyLevelOptionEnumKey;
